import * as styledComponents from 'styled-components';

const {default: styled, css, createGlobalStyle, keyframes, ThemeProvider} = styledComponents;

export {styled, css, createGlobalStyle, keyframes, ThemeProvider};
